'use strict';

var novicell = novicell || {};

novicell.contactsSearch = novicell.contactsSearch || new function () {
    var contactFilterToggle = document.querySelector('#js-contacts-search-filter-toggle');
    var contactFilterOverlay = document.querySelector('#js-contacts-search-filter-overlay');

    if (!contactFilterToggle || !contactFilterOverlay) {
        return;
    }

    contactFilterToggle.addEventListener('click', function (e) {
        e.preventDefault();

        novicell.helper.toggleClass(contactFilterOverlay, 'contacts-search-section__filter-block-form--active');
    });
}();
